module.exports = __webpack_public_path__ + "static/media/SM-ST2-TRIAL.7054e8d0.mp3";